import React, { useState } from "react";

const Newsletter: React.FC = () => {
  const [subscriberEmail, setSubscriberEmail] = useState("");

  return (
    <div className="rounded border bg-white p-10 text-center">
      <h2 className="mb-4 text-3xl font-semibold text-gray-700">
        Subscribe to our newsletter!
      </h2>
      <p className="mb-10 text-neutral-500">
        Sign up for our newsletter and stay in the loop on all the latest
        updates and exclusive content.
      </p>
      <form
        className=" relative flex justify-center"
        action="https://app.gumroad.com/follow_from_embed_form"
        method="post"
        id="gumroad-follow-form-embed"
      >
        <input
          type="hidden"
          className="hidden"
          name="seller_id"
          value={`${process.env.GATSBY_GUMROAD_SELLER_ID}`}
        />
        <input
          id="gumroad-follow-form-embed-input"
          className="focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md border border-slate-300 bg-white py-4 pl-4 pr-32 text-black shadow-sm placeholder:italic placeholder:text-slate-400 focus:outline-none focus:ring-1 sm:text-sm xl:w-3/4 2xl:w-2/4"
          placeholder="Your Email Address"
          type="email"
          name="email"
          value={subscriberEmail}
          onChange={(e) => setSubscriberEmail(e.target.value)}
        />
        <button
          id="gumroad-follow-form-embed-button"
          className="btn-primary absolute right-[4%] top-[14%] sm:top-[13%] md:right-[3%] md:top-[13%] xl:right-[15%] 2xl:right-[26.5%]"
          type="submit"
        >
          Follow
        </button>
      </form>
    </div>
  );
};

export default Newsletter;
